module.exports = __webpack_public_path__ + "img/广州仓库2.aaba8a84.jpg";